import IcAdd from './IcAdd'

export default IcAdd
